import styled from "styled-components"
import { Container } from "react-bootstrap"

export const AboutContainer = styled(Container)`
  min-height: 100vh;
  position: relative;
  top: 200px;
`
